import React, { useContext, useEffect, useState } from 'react';

export const EsimVerifyPhone = () => {
    return (<><div className='esimContainer' style={{ marginBottom: 16 }}>
        <div className='spliter'></div>
        <div className='title' >שימו לב!</div>
        <div className='subtitle' style={{ fontSize: 18 }}>אם רכשתם eSIM, לפני ההתקנה, יש לוודא שאתם נמצאים ליד חיבור WiFi יציב.</div>
    </div></>)
};

export default EsimVerifyPhone;